import ApiClient from './ApiClient'

const API_NAME = 'WeConnect'
const client = new ApiClient(API_NAME)

/**
 * ステップ系API
 */
export default {
  /**
   * ステップを取得する
   * @param {number} businessId 案件ID
   * @param {taskParams} query タスクに紐づくステップ
   * @returns {Promise<any>} レスポンス
   */
  getStep(businessId, query) {
    return client.get(`/business/${businessId}/step`, query)
  },

  /**
   * タスク一覧を取得する
   * @param {number} businessId 案件ID
   * @param {number} stepId ステップID
   * @returns {Promise<any>} レスポンス
   */
  getTaskList(businessId, stepId) {
    return client.get(`/business/${businessId}/step/${stepId}/task`)
  },

  /**
   * タスク種別を取得する
   * @param {number} businessId 案件ID
   * @returns {Promise<any>} レスポンス
   */
  getTaskTypes(businessId) {
    return client.get(`/business/${businessId}/step-task-type`)
  },

  /**
   * タスク情報を取得する
   * @param {number} businessId 案件ID
   * @param {number} taskId タスクID
   * @returns {Promise<any>} レスポンス
   */
  task(businessId, taskId) {
    return client.get(`/business/${businessId}/step/task/${taskId}`)
  },

  /**
   * タスク状態情報を取得する
   * @param {number} businessId 案件ID
   * @param {number} taskId タスク状態ID
   * @returns {Promise<any>} レスポンス
   */
  taskStatus(businessId, taskId) {
    return client.get(`/business/${businessId}/step/task-status/${taskId}`)
  },

  /**
   * タスクの状態を登録・更新する
   * @param {number} businessId 案件ID
   * @param {number} taskStatusId タスク状態ID
   * @param {object} data タスク状態データ
   * @returns {Promise<any>} レスポンス
   * 
   * id=0:INSERT, 1以上:UPDATE
   */
  updateStatus(businessId, taskStatusId, data) {
    const url = `/business/${businessId}/step/task-status/${taskStatusId}`
    return client.put(url, data)
  },

  /**
   * タスクを削除・復元する
   * @param {number} businessId 案件ID
   * @param {number} taskStatusId タスク状態ID
   * @param {object} data タスク状態データ
   * @returns {Promise<any>} レスポンス
   * 
   * unvailable=true: 削除, false: 復元
   */
  delete(businessId, taskStatusId, data) {
    const url = `/business/${businessId}/step/task-status/${taskStatusId}`
    return client.delete(url, data)
  },

  /**
   * タスクを完了・未完了にする
   * @param {number} businessId 案件ID
   * @param {number} taskStatusId タスク状態ID
   * @param {object} data タスク状態データ
   * @returns {Promise<any>} レスポンス
   * 
   * complete=true: 完了, false: 未完了
   */
  complete(businessId, taskStatusId, data) {
    const url = `/business/${businessId}/step/task-status-complete/${taskStatusId}`
    return client.put(url, data)
  },

  /**
   * CSVをダウンロードする
   * @param {number} businessId 案件ID
   * @returns {Promise<any>} レスポンス
   */
  download(businessId, stepIds) {
    const base = `/business/${businessId}/step/task/download/`

    if (typeof stepIds === 'undefined') {
      location.href = base
      return false
    }

    const query = stepIds.map(id => `step_id=${id}`).join('&')
    const url = query.length > 0 ? `${base}?${query}` : base

    return client.get(url)
  },

  /**
   * タスクの状態を一括登録・更新する
   * @param {number} businessId 案件ID
   * @param {object} data タスク状態一括更新データ
   * @returns {Promise<any>} レスポンス
   */
  updateStatusBulk(businessId, data) {
    const url = `/business/${businessId}/step/task-status-bulk`
    return client.put(url, data)
  },
}
